import { FormControl, FormHelperText, FormLabel, Typography } from '@mui/material';
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { DatePicker, dateTimePickerTabsClasses, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import * as React from 'react';
import "./datepicker.css";
import moment from 'moment';
import Helpers from '../../helpers/helpers';


export default function DatePickerFilter({ values, setFormValues, error, required, title, name, handlecheck, check, disabled, InputProps, readOnly, format }) {
    const outerTheme = createTheme({

    });
    const handleDateChange = (e) => {
        const date = e;
        const momentDate = moment(date, 'ddd MMM DD YYYY hh:mm:ss [GMT]ZZ (zz)');
        const isoString = momentDate.format('YYYY-MM-DD');
        if (Helpers.isNullOrEmpty(name)) {
            setFormValues(isoString)
        } else {
            setFormValues((prevValues) => ({
                ...prevValues,
                [name]: isoString
            }))
        }

    }
    return (
        <>
            <FormControl variant="outlined" fullWidth>
                {
                    title &&
                    <FormLabel style={{ fontFamily: 'Manrope-Bold', fontSize: 14 }}>{title}{required && <span style={{ color: "red" }}>*</span>}</FormLabel>
                }
                <ThemeProvider theme={outerTheme}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                            // error={true}
                            value={values === '' ? null : values}
                            hiddenLabel={true}
                            disabled={disabled}
                            InputProps={InputProps}
                            format={format ? format : 'dd/MM/yyyy'}
                            // onChange={(e) => check ? handlecheck(e) : setFormValues((prevValues) => ({
                            //     ...prevValues,
                            //     [name]: moment(e, 'YYYY-MM-DD hh:mm:ss').toDate()
                            // }))}
                            slots={{
                                openPickerIcon: () => <i className="ri-expand-up-down-line " style={{ zIndex: 2 }} />
                            }}
                            onChange={(e) => handleDateChange(e)}
                            sx={{
                                '& .MuiInputBase-input': {
                                    color: "#101010",
                                    height: "9px",
                                },
                                "& .MuiFormLabel-root": {
                                    fontSize: "1rem",
                                    // top: "-7px",
                                },
                                "& .MuiOutlinedInput-root": {
                                    height: "34px",
                                    borderRadius: "20px",
                                    minWidth: "180px"
                                },
                                "& .Mui-selected.Mui-disabled": {
                                    color: "rgba(0, 0, 0)", // (default alpha is 0.38)，
                                },
                                backgroundColor: disabled ? 'rgb(241, 243, 244)' : 'white',
                                borderRadius: 10
                            }}
                            control={(params) => <TextField size="small" InputProps={InputProps} {...params} />}
                        />
                    </LocalizationProvider></ThemeProvider>
            </FormControl>
            {error && <FormHelperText sx={{ color: "red" }}>{error || ""}</FormHelperText>}
        </>


    );
}
